// Secure logging utility for production
// eslint-disable-next-line no-console
const nativeConsole = { log: console.log, error: console.error, warn: console.warn, info: console.info };

class Logger {
  private static isDevelopment = process.env.NODE_ENV === 'development';

  private static sensitiveKeys = [
    'password', 'token', 'secret', 'key', 'auth', 'credential',
    'mot_de_passe', 'odoo_password', 'postgres_password', 'wordpress_password',
    'mariadb_root_password', 'mariadb_user_password', 'git_token',
    'access_token', 'refresh_token', 'authorization'
  ];

  static log(message: string, data?: unknown): void {
    if (this.isDevelopment) {
      nativeConsole.log(message, data !== undefined ? this.sanitizeData(data) : '');
    }
  }

  static error(message: string, error?: unknown): void {
    if (this.isDevelopment) {
      nativeConsole.error(message, error !== undefined ? this.sanitizeData(error) : '');
    } else {
      // In production, only log generic error without sensitive data
      nativeConsole.error(message);
    }
  }

  static warn(message: string, data?: unknown): void {
    if (this.isDevelopment) {
      nativeConsole.warn(message, data !== undefined ? this.sanitizeData(data) : '');
    }
  }

  static info(message: string, data?: unknown): void {
    if (this.isDevelopment) {
      nativeConsole.info(message, data !== undefined ? this.sanitizeData(data) : '');
    }
  }

  // Sanitize sensitive data before logging
  static sanitizeData(data: unknown): unknown {
    if (data === null || data === undefined) return data;
    if (typeof data !== 'object') return data;

    // Handle arrays
    if (Array.isArray(data)) {
      return data.map(item => this.sanitizeData(item));
    }

    const dataRecord = data as Record<string, unknown>;
    const sanitized: Record<string, unknown> = { ...dataRecord };

    Object.keys(sanitized).forEach(key => {
      const keyLower = key.toLowerCase();
      if (this.sensitiveKeys.some(sensitive => keyLower.includes(sensitive))) {
        sanitized[key] = '***HIDDEN***';
      } else if (typeof sanitized[key] === 'object' && sanitized[key] !== null) {
        sanitized[key] = this.sanitizeData(sanitized[key]);
      }
    });

    return sanitized;
  }
}

export { Logger };
export default Logger;
